import { render } from "./QHLSCenterView.vue?vue&type=template&id=1f79c3db&scoped=true"
import script from "./QHLSCenterView.vue?vue&type=script&lang=js"
export * from "./QHLSCenterView.vue?vue&type=script&lang=js"

import "./QHLSCenterView.vue?vue&type=style&index=0&id=1f79c3db&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f79c3db"]])

export default __exports__